module.exports = __webpack_public_path__ + "img/user.7821e5f2.svg";